import React from "react";
import { Container, Navbar } from "shards-react";

export default class MainNavbar extends React.Component
{
render() {
    return (
      <div className="main-navbar bg-white">
        <Container fluid className="p-0">
          <Navbar type="light" className="align-items-stretch justify-content-end flex-md-nowrap p-0">
              <div onClick={() => this.props.auth.logout()}>
              <span className="m-auto d-none d-md-inline actions-nav">
                <i className="material-icons material-icons-outlined">
                power_settings_new
                </i>
              </span>
              </div>
          </Navbar>
        </Container>
      </div>
    );
    }
};


// WEBPACK FOOTER //
// ./src/layouts/MainNavbar/MainNavbar.js